export const createModalsSlice = (set) => ({
    modalOpen: false,
    openModal: () => set({ modalOpen: true }),
    closeModal: () => set({ modalOpen: false }),
    toggleModal: () => set((state) => ({ modalOpen: !state.modalOpen })),
});
//# sourceMappingURL=modalsSlice.js.map